export default "__VITE_ASSET__DvG9ZjeZ__"